/** Canonical public site origin (www). Override at build with VITE_SITE_URL. */
export const SITE_ORIGIN =
  import.meta.env.VITE_SITE_URL?.replace(/\/$/, "") ??
  "https://www.specopsengineers.com";

export const SITE_NAME = "SpecOps Engineers";
